import {createStore} from '../alt';
import cookie from 'react-cookie';

import SingleObjectResource, {InvalidResponseCode} from '../resources/GenericResource';
import CandidateActions from '../actions/CandidateActions';


const CandidateSource = {

    getCandidates() {
        return {
            remote(state, shiftId) {
                const query = '?hiring__shift_id=' + shiftId;
                return new SingleObjectResource(DJ_CONST.API.candidateList + query).fetch();
            },

            success: CandidateActions.getCandidatesSuccess,
            error: CandidateActions.getCandidatesFailed
        }
    },

    getCandidate() {
        return {
            remote(state, pk) {
                return new SingleObjectResource(DJ_CONST.API.candidateDetail).fetch({pk});
            },

            success: CandidateActions.getCandidateSuccess,
            error: CandidateActions.getCandidateFailed
        }
    },

    getPotentialCandidates() {
        return {
            remote(state, positionId, rate) {
                return new SingleObjectResource(DJ_CONST.API.candidatePotentialCandidates).post(null, {
                    'position': positionId,
                    'rate': rate
                });
            },

            success: CandidateActions.getPotentialCandidatesSuccess,
            error: CandidateActions.getPotentialCandidatesFailed
        }
    },

    updateCandidateDates() {
        return {
            remote(state, data, pk) {
                return new SingleObjectResource(DJ_CONST.API.candidateUpdateIgnoredDates).post({pk}, data);
            },

            success: CandidateActions.getUpdateCandidateDatesSuccess,
            error: CandidateActions.getUpdateCandidateDatesFailed
        }
    },

    saveProfile() {
        return {
            remote(state, pk, data) {
                if (pk) {
                    return new SingleObjectResource(DJ_CONST.API.candidateDetail).patch({pk}, data);
                } else {
                    return new SingleObjectResource(DJ_CONST.API.candidateList).post(null, data);
                }
            },

            success: CandidateActions.getSaveProfileSuccess,
            error: CandidateActions.saveProfileFailed
        }
    }
};

class CandidateStore {
    constructor() {
        this.candidates = null;
        this.curCandidate = {};
        this.candidatesLoaded = false;
        this.potentialCandidates = 0;
        this.getCandidatesError = null;
        this.candidateError = {};
        this.settingsSaved = false;
        this.exportAsync(CandidateSource);
        this.bindActions(CandidateActions);
    }

    onGetSaveProfileSuccess(data) {
        const prevProf = this.curCandidate.professions;
        const newProf = data.professions;
        /*
        * To decide if we need to override filters minimum price we first need to check if the minimum price has changed
        * To do that we find the minimum price for existing professions, then the same for new and updated list.
        * */
        if (prevProf && newProf) {
            let prevMin = parseFloat(prevProf[0].min_hourly_rate);
            let newMin = parseFloat(newProf[0].min_hourly_rate);
            for (let i = 1; i < prevProf.length; i++) {
                const p = parseFloat(prevProf[i].min_hourly_rate);
                if (p < prevMin) {
                    prevMin = p;
                }
            }
            for (let i = 1; i < newProf.length; i++) {
                const p = parseFloat(newProf[i].min_hourly_rate);
                if (p < newMin) {
                    newMin = p;
                }
            }

            if (newMin !== prevMin) {
                const filters = cookie.load('filters') || null;
                const newValue = 'rate_0=' + newMin.toString();
                let valuesList;
                if (filters) {
                    valuesList = filters.slice(1).split('&');
                    let i;
                    for (i = 0; i < valuesList.length; i++) {
                        if (valuesList[i].indexOf('rate_0') > -1) {
                            break;
                        }
                    }
                    valuesList[i] = newValue;
                } else {
                    valuesList = [newValue];
                }
                cookie.save('filters', '?' + valuesList.join('&'));
            }
        }
        this.curCandidate = data;
        this.setState({settingsSaved: true, candidateError: {}});
        setTimeout(() => {
            this.setState({settingsSaved: false})
        }, 5000);
    }

    onSaveProfileFailed(data) {''
        this.setState({candidateError: data.errors});
    }

    onClearCandidates() {
        this.setState({candidates: [], candidatesLoaded: false});
    }

    onGetCandidateSuccess(curCandidate) {
        this.setState({curCandidate});
    }

    onMergeErrorsIntoState(candidateError) {
        this.setState({candidateError});
    }

    onGetPotentialCandidatesSuccess(potentialCandidates) {
        this.setState({potentialCandidates: potentialCandidates.potential_candidates});
    }

    onGetCandidatesFailed(getCandidatesError) {
        this.setState({getCandidatesError, candidatesLoaded: true});
    }

    onGetCandidatesSuccess(candidates) {
        this.setState({candidates, candidatesLoaded: true});
    }

    onUpdateCandidateHiring(hiring) {
        for ( let i=0; i<this.candidates.length; i++ ) {
            const c = this.candidates[i];
            if ( c.id === hiring.candidate ) {
                c.hiring = hiring;
                break;
            }
        }
    }
}

export default createStore(CandidateStore, 'CandidateStore', module);



/** WEBPACK FOOTER **
 ** ./app/src/stores/CandidateStore.js
 **/